import Game from "./Game";

function component() {
    const element = document.createElement('div');
    const g = new Game(element);

    return element;
}

document.body.appendChild(component());